import List from './components/List'
import ListEvents from './components/ListEvents'

import Store from './components/Store'

import Form from './components/Form'
import FormBasicData from './components/form/BasicData'
import FormModalities from './components/form/Modalities'
import FormPaperTypes from './components/form/PaperTypes'
import FormEvaluations from './components/form/Evaluations'

import Presence from './components/Presence'

import Show from './components/Show'
import ShowHome from './components/show/Home'
import RegistrationsHome from './components/show/Registrations'
import PapersHome from './components/show/Papers'

import Reports from './components/reports/Reports'
import ReportsAdmin from './components/reports/ReportsAdmin'
import ReportsFinals from './components/reports/ReportsFinals'
import ReportsMinicursos from './components/reports/ReportsMinicursos'

export default [
  {path: '/event', component: List, name: 'event.index'},
  {path: '/event/store', component: Store, name: 'event.store', props: true},
  {
    path: '/event/:id',
    component: Form,
    name: 'event.update',
    children: [
      {
        path: 'basic-data',
        component: FormBasicData,
        name: 'event.update.basic-data',
        meta: {permission: 'event.update'}
      },
      {
        path: 'modalities',
        component: FormModalities,
        name: 'event.update.modalities',
        meta: {permission: 'event.update'}
      },
      {
        path: 'paper-types',
        component: FormPaperTypes,
        name: 'event.update.paper-types',
        meta: {permission: 'event.update'}
      },
      {
        path: 'evaluations',
        component: FormEvaluations,
        name: 'event.update.evaluations',
        meta: {permission: 'event.update'}
      }
    ]
  },
  {
    path: '/event/:id/events',
    component: ListEvents,
    name: 'event.events.index',
    meta: {permission: 'event.index'}
  },
  {
    path: '/event/:eventMainId/show/:id',
    component: Show,
    name: 'event.show',
    children: [
      {path: '', component: ShowHome, name: 'event.show.home', props: true, meta: {permission: 'event.show'}},
      {
        path: 'registrations',
        component: RegistrationsHome,
        name: 'event.index.registrations',
        props: true,
        meta: {permission: 'event.show'}
      },
      {
        path: 'papers/status/:statusKey?',
        component: PapersHome,
        name: 'event.index.papers',
        props: true,
        meta: {permission: 'event.show'}
      }
    ]
  },
  {
    path: '/presence/event/:id',
    component: Presence,
    name: 'event.presence',
    meta: {permission: 'registration_activity.store'}
  },
  {
    path: '/reports/event/:id',
    component: Reports,
    name: 'event.report',
    meta: {permission: 'event.search'}
  },
  {
    path: '/reports-admin/event/:id',
    component: ReportsAdmin,
    name: 'event.report-admin',
    meta: {permission: 'event.search'}
  },
  {
    path: '/reports-finals/event/:id',
    component: ReportsFinals,
    name: 'event.report-finals',
    meta: {permission: 'event.search'}
  },
  {
    path: '/reports-minicursos/event/:id',
    component: ReportsMinicursos,
    name: 'event.report-minicursos',
    meta: {permission: 'event.search'}
  }
]



// WEBPACK FOOTER //
// ./src/app/domains/event/routes.js